import { Component, OnInit } from '@angular/core';
import { OrderDto, PlayerDto, TacticDto } from '../../../models';
import { OrderService, SecurityService, TeamService, PlayerService, NationalTeamService} from '../../../services';
import { FixtureService } from 'app/services/fixture.service';
import { TeamCardsDto } from 'app/models/dtos/team-cards.dto';
import { FixtureFullDto } from 'app/models/dtos/fixture-full.dto';
import { Router } from '@angular/router';


@Component({
    selector: 'national-tactic-page',
    templateUrl: './national-tactic.page.html',
    styleUrls: ['./national-tactic.page.scss'],
})
export class NationalTacticPage implements OnInit {
    order: OrderDto;
    isInitialized: boolean = false;
    currentTactic: TacticDto;
    
    currentTeamId: number;
    teamFormUrl: string;

    players: PlayerDto[];

    allTactics: any[];

    opponentPlayers: PlayerDto[];
     
    teamCards: TeamCardsDto;

    nextFixtureWithDetails: FixtureFullDto;

    canSetupPrice: boolean = false;


    constructor(
        private orderService: OrderService,
        private teamService: TeamService,
        private playerService: PlayerService,
        private securityService: SecurityService,
        private fixtureService: FixtureService,
        private nationalTeamService: NationalTeamService,
        private router: Router) {
    }

    ngOnInit() { 
        this.securityService.getCachedAuths() 
        .subscribe(authResult => {
            if (!authResult.nationalTeamId) {
                this.router.navigate(['roster']);
            } else {
                this.currentTeamId = authResult.nationalTeamId;

                this.nationalTeamService.getSquad()
                    .subscribe(result => {
                        if (!result || result.length < 18) {
                            this.router.navigate(['roster']);
                        } else {
                            this.players = result;

                            this.loadData();
                        }
                    })
            }
        });
    }


    private loadData() {
        this.orderService.getNationalOrder()
            .subscribe(result => {
                this.order = result;

                this.selectTactic(1);

                this.loadNextOpponent();

                this.loadTeamCards();

                this.teamService.getForm(this.currentTeamId)
                    .subscribe(formResult => {
                        this.teamFormUrl = formResult;

                        this.isInitialized = true;
                    })
             
            },
            error => {
                console.log(error);
            })
    }

    private selectTactic(number: number) {
        this.currentTactic = this.order.tactics.find(item => item.number == number);
        
    }

    private loadNextOpponent() {
        this.fixtureService.getNationalNextOpponent()
            .subscribe(result => {

                if (result) {
                    let nextOpponent = result.homeTeamId == this.currentTeamId ? result.visitorTeamId : result.homeTeamId;
                
                    this.nationalTeamService.getSquadById(nextOpponent)
                        .subscribe(result => {
                            this.opponentPlayers = result;
                        });
                }
            });

        this.fixtureService.getNationalNextOpponentWithDetails()
            .subscribe(result => {
                if (result) {
                    this.nextFixtureWithDetails = result;
                    this.canSetupPrice = result.homeTeamId == this.currentTeamId;
                }
            });
    }



    private loadTeamCards() {

        this.nationalTeamService.getCards(this.currentTeamId)
            .subscribe(result => {
                this.teamCards = result;
            })
    }
}
